import * as React from "react";

export const getColorString = (type, color) => {
  let newColor = color;
  try {
    newColor = JSON.parse(color);
  } catch (e) {
    newColor = color; // default color
  }
  if (type && newColor) {
    if (type === "hex") {
      let hexColor = newColor;
      if (typeof newColor === "string" && newColor.includes('"')) {
        hexColor = newColor.replace(/"/g, "");
      }
      return color.startsWith("#") ? hexColor : `#${hexColor}`;
    } else if (type === "rgb") {
      return `rgb(${newColor.r}, ${newColor.g}, ${newColor.b})`;
    } else if (type === "hsb") {
      return `hsb(${newColor.h}, ${newColor.s}, ${newColor.b})`;
    }
  } else {
    return "";
  }
};

export const capitalizeFirstLetter = (string) => {
  return string ? string[0].toUpperCase() + string.slice(1) : "";
};

export const capitalizeWords = (str) => {
  if (!str) {
    return "";
  }
  if (str.indexOf(" ") === -1) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
};

export const priceOptions = [
  {
    value: 50000,
    label: "$50,000",
  },
  {
    value: 75000,
    label: "$75,000",
  },
  {
    value: 100000,
    label: "$100,000",
  },
  {
    value: 125000,
    label: "$125,000",
  },
  {
    value: 150000,
    label: "$150,000",
  },
  {
    value: 175000,
    label: "$175,000",
  },
  {
    value: 200000,
    label: "$200,000",
  },
  {
    value: 225000,
    label: "$225,000",
  },
  {
    value: 250000,
    label: "$250,000",
  },
  {
    value: 275000,
    label: "$275,000",
  },
  {
    value: 300000,
    label: "$300,000",
  },
  {
    value: 325000,
    label: "$325,000",
  },
  {
    value: 350000,
    label: "$350,000",
  },
  {
    value: 375000,
    label: "$375,000",
  },
  {
    value: 400000,
    label: "$400,000",
  },
  {
    value: 425000,
    label: "$425,000",
  },
  {
    value: 450000,
    label: "$450,000",
  },
  {
    value: 475000,
    label: "$475,000",
  },
  {
    value: 500000,
    label: "$500,000",
  },
  {
    value: 550000,
    label: "$550,000",
  },
  {
    value: 600000,
    label: "$600,000",
  },
  {
    value: 650000,
    label: "$650,000",
  },
  {
    value: 700000,
    label: "$700,000",
  },
  {
    value: 750000,
    label: "$750,000",
  },
  {
    value: 800000,
    label: "$800,000",
  },
  {
    value: 850000,
    label: "$850,000",
  },
  {
    value: 900000,
    label: "$800,000",
  },
  {
    value: 950000,
    label: "$950,000",
  },
  {
    value: 1000000,
    label: "$1,000,000",
  },
  {
    value: 1100000,
    label: "$1,100,000",
  },
  {
    value: 1200000,
    label: "$1,200,000",
  },
  {
    value: 1300000,
    label: "$1,300,000",
  },
  {
    value: 1400000,
    label: "$1,400,000",
  },
  {
    value: 1500000,
    label: "$1,500,000",
  },
  {
    value: 1600000,
    label: "$1,600,000",
  },
  {
    value: 1700000,
    label: "$1,700,000",
  },
  {
    value: 1800000,
    label: "$1,800,000",
  },
  {
    value: 1900000,
    label: "$1,900,000",
  },
  {
    value: 2000000,
    label: "$2,000,000",
  },
  {
    value: 2250000,
    label: "$2,250,000",
  },
  {
    value: 2500000,
    label: "$2,500,000",
  },
  {
    value: 2750000,
    label: "$2,750,000",
  },
  {
    value: 3000000,
    label: "$3,000,000",
  },
  {
    value: 3500000,
    label: "$3,500,000",
  },
  {
    value: 4000000,
    label: "$4,000,000",
  },
  {
    value: 4500000,
    label: "$4,500,000",
  },
  {
    value: 5000000,
    label: "$5,000,000",
  },
  {
    value: 6000000,
    label: "$6,000,000",
  },
  {
    value: 7000000,
    label: "$7,000,000",
  },
  {
    value: 8000000,
    label: "$8,000,000",
  },
  {
    value: 9000000,
    label: "$9,000,000",
  },
  {
    value: 10000000,
    label: "$10,000,000",
  },
  {
    value: 12000000,
    label: "$12,000,000",
  },
  {
    value: 15000000,
    label: "$15,000,000",
  },
  {
    value: 20000000,
    label: "$20,000,000",
  },
  {
    value: 25000000,
    label: "$25,000,000",
  },
  {
    value: 30000000,
    label: "$30,000,000",
  },
  {
    value: 35000000,
    label: "$35,000,000",
  },
  {
    value: 40000000,
    label: "$40,000,000",
  },
  {
    value: 45000000,
    label: "$45,000,000",
  },
  {
    value: 50000000,
    label: "$50,000,000",
  },
  {
    value: 55000000,
    label: "$55,000,000",
  },
  {
    value: 60000000,
    label: "$60,000,000",
  },
  {
    value: 65000000,
    label: "$65,000,000",
  },
  {
    value: 70000000,
    label: "$70,000,000",
  },
  {
    value: 75000000,
    label: "$75,000,000",
  },
  {
    value: 80000000,
    label: "$80,000,000",
  },
  {
    value: 85000000,
    label: "$85,000,000",
  },
  {
    value: 90000000,
    label: "$90,000,000",
  },
  {
    value: 95000000,
    label: "$95,000,000",
  },
  {
    value: 100000000,
    label: "$100,000,000",
  },
  // {
  //     value: 105000000,
  //     label: '$105,000,000'
  // },
  // {
  //     value: 110000000,
  //     label: '$110,000,000'
  // },
  // {
  //     value: 115000000,
  //     label: '$115,000,000'
  // },
  // {
  //     value: 120000000,
  //     label: '$120,000,000'
  // },
];

export const landSizeOptions = [
  {
    value: 200,
    label: "200 ㎡",
  },
  {
    value: 400,
    label: "400 ㎡",
  },
  {
    value: 600,
    label: "600 ㎡",
  },
  {
    value: 800,
    label: "800 ㎡",
  },
  {
    value: 1000,
    label: "1,000 ㎡",
  },
  {
    value: 1200,
    label: "1,200 ㎡",
  },
  {
    value: 1500,
    label: "1,500 ㎡",
  },
  {
    value: 1750,
    label: "1,750 ㎡",
  },
  {
    value: 2000,
    label: "2,000 ㎡",
  },
  {
    value: 3000,
    label: "3,000 ㎡",
  },
  {
    value: 4000,
    label: "4,000 ㎡",
  },
  {
    value: 5000,
    label: "5,000 ㎡",
  },
  {
    value: 6000,
    label: "6,000 ㎡",
  },
  {
    value: 7000,
    label: "7,000 ㎡",
  },
  {
    value: 8000,
    label: "8,000 ㎡",
  },
  {
    value: 9000,
    label: "9,000 ㎡",
  },
  {
    value: 10000,
    label: "10,000 ㎡",
  },
];

export const states = [
  "New South Wales",
  "Queensland",
  "South Australia",
  "Tasmania",
  "Victoria",
  "Western Australia",
  "Australian Capital Territory",
  "Northern Territory",
];
export const cityCouncil = [
  "Adelaide Hills Council",
  "Adelaide Plains Council",
  "Banyule City Council",
  "Ballarat City Council",
  "Bass Coast Shire Council",
  "Baw Baw Shire Council",
  "Bayside City Council",
  "Blacktown City Council",
  "Boroondara City Council",
  "Brimbank City Council",
  "Brisbane City Council",
  "Bundaberg Regional Council",
  "Campbelltown City Council - NSW",
  "Campbelltown City Council - SA",
  "Camden Council",
  "Cairns Regional Council",
  "Camden Council",
  "Campaspe Shire Council",
  "Canterbury-Bankstown Council",
  "Cardinia Shire Council",
  "Casey City Council",
  "Central Coast Council",
  "Central Highlands Regional Council",
  "Central Highlands Regional Council",
  "Cessnock City Council",
  "Charles Sturt City Council",
  "City of Adelaide",
  "City of Burnside",
  "City of Gawler",
  "City of Gold Coast",
  "City of Holdfast Bay",
  "City of Joondalup",
  "City of Kwinana",
  "City of Lake Macquarie",
  "City of Logan",
  "City of Marion",
  "City of Mitcham",
  "City of Monash",
  "City of Mount Barker",
  "City of Norwood, Payneham & St Peters",
  "City of Onkaparinga",
  "City of Parramatta",
  "City of Playford",
  "City of Port Adelaide Enfield",
  "City of Prospect",
  "City of Ryde",
  "City of Salisbury",
  "City of Sydney",
  "City of Tea Tree Gully",
  "City of Unley",
  "City of Victor Harbor",
  "City of Vincent",
  "City of Wanneroo",
  "City of West Torrens",
  "City of Whittlesea",
  "City of Willoughby",
  "City of Yarra",
  "Cumberland City Council",
  "Darebin City Council",
  "Fairfield City Council",
  "Fraser Coast Regional Council",
  "Frankston City Council",
  "Geelong City Council",
  "Glen Eira City Council",
  "Greater Bendigo City Council",
  "Greater Dandenong City Council",
  "Greater Geelong City Council",
  "Greater Shepparton City Council",
  "Gympie Regional Council",
  "Hawkesbury City Council",
  "Hume City Council",
  "Ipswich City Council",
  "Kempsey Shire Council",
  "Kiama Municipal Council",
  "Kingborough Council",
  "Kingston City Council",
  "Knox City Council",
  "Ku-ring-gai Council",
  "Lake Macquarie City Council",
  "Latrobe City Council",
  "Light Regional Council",
  "Liverpool City Council",
  "Logan City Council",
  "Macedon Ranges Shire Council",
  "Maitland City Council",
  "Manningham City Council",
  "Maribyrnong City Council",
  "Maroondah City Council",
  "Melbourne City Council",
  "Melton City Council",
  "Mildura Rural City Council",
  "Mitchell Shire Council",
  "Moira Shire Council",
  "Monash City Council",
  "Mornington Peninsula Shire Council",
  "Moreland City Council",
  "Moreton Bay Regional Council",
  "Mount Barker District Council",
  "Moyne Shire Council",
  "Moyne Shire Council",
  "Nillumbik Shire Council",
  "Noosa Shire Council",
  "North Sydney Council",
  "Northern Beaches Council",
  "Parramatta City Council",
  "Penrith City Council",
  "Port Phillip City Council",
  "Port Stephens Council",
  "Pyrenees Shire Council",
  "Redland City Council",
  "Scenic Rim Regional Council",
  "Shellharbour City Council",
  "Shoalhaven City Council",
  "South Gippsland Shire Council",
  "Southern Grampians Shire Council",
  "Stonnington City Council",
  "Surf Coast Shire Council",
  "Sutherland Shire Council",
  "Swan Hill Rural City Council",
  "The Hills Shire Council",
  "The Town of Gawler",
  "Tweed Shire Council",
  "Warrnambool City Council",
  "Wellington Shire Council",
  "Whitehorse City Council",
  "Whittlesea City Council",
  "Wollondilly Shire Council",
  "Wollongong City Council",
  "Wyndham City Council",
  "Yarra Ranges Shire Council",
  "Yarra City Council",
];
export const growthRegion = [
  "Adelaide Hills Growth Areas",
  "Adelaide North Growth Areas",
  "Adelaide South Growth Areas",
  "Ballarat Growth Areas",
  "Cairns (Far North Queensland Region)",
  "Central Coast Growth Areas",
  "Geelong Growth Areas",
  "Gippsland Regional Growth Areas",
  "Gold Coast Growth Areas",
  "Greater Bendigo Growth Areas",
  "Greater Brisbane Growth Areas",
  "Greater Newcastle Growth Areas (The Hunter Region)",
  "Hervey Bay (Wide Bay-Burnett Region)",
  "Melbourne East Corridor",
  "Melbourne North Corridor",
  "Melbourne South East Corridor",
  "Melbourne West Corridor",
  "Sunshine Coast Growth Areas",
  "Sydney North West Growth Areas",
  "Sydney South West Growth Areas",
  "Toowoomba Growth Areas",
  "Townsville (North Queensland Region)",
  "Wollongong (Illawarra-Shoalhaven Region)",
];

export const regions = [
  [
    ["Melbourne North Corridor", "Greater Bendigo Growth Areas"],
    ["Melbourne West Corridor", "Melbourne East Corridor"],
    ["Melbourne South East Corridor", "Ballarat Growth Areas"],
  ],
  [
    ["Geelong Growth Areas", "Greater Brisbane Growth Areas"],
    ["Townsville (North Queensland Region)", "Gold Coast Growth Areas"],
    ["Cairns (Far North Queensland Region)", "Sunshine Coast Growth Areas"],
  ],
  [
    ["Sydney North West Growth Areas", "Sydney South West Growth Areas"],
    ["Central Coast Growth Areas", "Adelaide North Growth Areas"],
    ["Wollongong (Illawarra-Shoalhaven Region)", "Adelaide Hills Growth Areas"],
  ],
];

// export const landEstateState = ["VIC", "QLD", "NSW", "SA"]

// export const vicRegions = ["Melbourne North Corridor", "Greater Bendigo Growth Areas", "Melbourne West Corridor", "Melbourne East Corridor", "Melbourne South East Corridor", "Ballarat Growth Areas", "Geelong Growth Areas", "Greater Geelong Growth Areas", "Gippsland regional Growth Areas"];

// export const qldRegions = ["Greater Brisbane Growth Areas", "Hervey Bay (Wide Bay-Burnett Region)", "Townsville (North Queensland Region)", "Gold Coast Growth Areas", "Cairns (Far North Queensland Region)", "Sunshine Coast Growth Areas", "Toowoomba Growth Areas"];

// export const nswRegions = ["Sydney North West Growth Areas", "Sydney South West Growth Areas", "Greater Newcastle Growth Areas(The Hunter Region)", "Central Coast Growth Areas", "Adelaide North Growth Areas", "Wollongong (Illawarra-Shoalhaven Region)"];

// export const saRegions = ["Adelaide North Growth Areas", "Adelaide South Growth Areas", "Adelaide Hills Growth Areas"];

export const landEstateState = {
  VIC: [
    "Melbourne North Corridor",
    "Greater Bendigo Growth Areas",
    "Melbourne West Corridor",
    "Melbourne East Corridor",
    "Melbourne South East Corridor",
    "Ballarat Growth Areas",
    "Geelong Growth Areas",
    "Greater Geelong Growth Areas",
    "Gippsland regional Growth Areas",
  ],
  QLD: [
    "Greater Brisbane Growth Areas",
    "Hervey Bay (Wide Bay-Burnett Region)",
    "Townsville (North Queensland Region)",
    "Gold Coast Growth Areas",
    "Cairns (Far North Queensland Region)",
    "Sunshine Coast Growth Areas",
    "Toowoomba Growth Areas",
  ],
  NSW: [
    "Sydney North West Growth Areas",
    "Sydney South West Growth Areas",
    "Greater Newcastle Growth Areas(The Hunter Region)",
    "Central Coast Growth Areas",
    "Adelaide North Growth Areas",
    "Wollongong (Illawarra-Shoalhaven Region)",
  ],
  SA: [
    "Adelaide North Growth Areas",
    "Adelaide South Growth Areas",
    "Adelaide Hills Growth Areas",
  ],
};

export const vicRegions = [
  "Melbourne North Corridor",
  "Greater Bendigo Growth Areas",
  "Melbourne West Corridor",
  "Melbourne East Corridor",
  "Melbourne South East Corridor",
  "Ballarat Growth Areas",
  "Geelong Growth Areas",
  "Greater Geelong Growth Areas",
  "Gippsland regional Growth Areas",
];

export const qldRegions = [
  "Greater Brisbane Growth Areas",
  "Hervey Bay (Wide Bay-Burnett Region)",
  "Townsville (North Queensland Region)",
  "Gold Coast Growth Areas",
  "Cairns (Far North Queensland Region)",
  "Sunshine Coast Growth Areas",
  "Toowoomba Growth Areas",
];

export const nswRegions = [
  "Sydney North West Growth Areas",
  "Sydney South West Growth Areas",
  "Greater Newcastle Growth Areas(The Hunter Region)",
  "Central Coast Growth Areas",
  "Adelaide North Growth Areas",
  "Wollongong (Illawarra-Shoalhaven Region)",
];

export const saRegions = [
  "Adelaide North Growth Areas",
  "Adelaide South Growth Areas",
  "Adelaide Hills Growth Areas",
];

export const supportedImageFileTypes = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "tiff",
  "tif",
  "webp",
  "svg",
  "ico",
];

export const supportedVideoFileTypes = [
  "mp4",
  "avi",
  "mov",
  "wmv",
  "mkv",
  "flv",
  "webm",
  "mpeg",
  "mpg",
  "3gp",
  "mts",
  "m2ts",
  "hevc",
  "h265",
  "mpd",
];

export const avatarBackgroundColors = [
  "#FFF59D", // Light Yellow
  "#90CAF9", // Light Blue
  "#A5D6A7", // Light Green
  "#FFCCBC", // Peach
  "#E1BEE7", // Lavender
  "#B2DFDB", // Mint
  "#F8BBD0", // Light Pink
  "#B3E5FC", // Sky Blue
  "#E0E0E0", // Light Gray
  "#FFE0B2", // Pale Orange
];

export const formatSecondsToHHMMSS = (totalSeconds) => {
  // const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Pad with leading zeros if necessary
  // const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return `${formattedMinutes}:${formattedSeconds}`;
};

export const countryCodes = [
  "+1 United States",
  "+1 Canada",
  "+44 United Kingdom",
  "+91 India",
  "+61 Australia",
  "+49 Germany",
  "+33 France",
  "+39 Italy",
  "+81 Japan",
  "+86 China",
  "+7 Russia",
  "+34 Spain",
  "+55 Brazil",
  "+27 South Africa",
  "+64 New Zealand",
  "+82 South Korea",
  "+31 Netherlands",
  "+46 Sweden",
  "+41 Switzerland",
  "+47 Norway",
  "+90 Turkey",
  "+20 Egypt",
  "+62 Indonesia",
  "+66 Thailand",
  "+98 Iran",
  "+972 Israel",
  "+353 Ireland",
  "+351 Portugal",
  "+420 Czech Republic",
  "+48 Poland",
  "+36 Hungary",
  "+65 Singapore",
  "+60 Malaysia",
  "+52 Mexico",
  "+54 Argentina",
  "+56 Chile",
  "+51 Peru",
  "+32 Belgium",
  "+420 Czech Republic",
  "+45 Denmark",
  "+358 Finland",
  "+372 Estonia",
  "+371 Latvia",
  "+370 Lithuania",
  "+389 North Macedonia",
  "+423 Liechtenstein",
  "+352 Luxembourg",
  "+995 Georgia",
  "+375 Belarus",
  "+501 Belize",
  "+502 Guatemala",
  "+503 El Salvador",
  "+504 Honduras",
  "+505 Nicaragua",
  "+506 Costa Rica",
  "+507 Panama",
  "+595 Paraguay",
  "+598 Uruguay",
  "+973 Bahrain",
  "+965 Kuwait",
  "+966 Saudi Arabia",
  "+971 UAE",
  "+974 Qatar",
  "+968 Oman",
  "+20 Egypt",
  "+212 Morocco",
  "+260 Zambia",
  "+263 Zimbabwe",
  "+260 Zambia",
  "+254 Kenya",
  "+256 Uganda",
  "+255 Tanzania",
  "+261 Madagascar",
  "+267 Botswana",
  "+260 Zambia",
  "+263 Zimbabwe",
  "+256 Uganda",
  "+258 Mozambique",
  "+27 South Africa",
];
